// ======================================================================
//  FixSystem 2.0 - App Utilities (ES6 Module)
//  Zestaw funkcji pomocniczych używanych przez Blazor i UI
// ======================================================================

export function downloadFile(filename, contentType, content) {
    const blob = new Blob([content], { type: contentType });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}

export function downloadFileFromUrl(url, filename) {
    const a = document.createElement("a");
    a.href = url;
    a.download = filename || "";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}

export function copyToClipboard(text) {
    return navigator.clipboard.writeText(text).catch(() => {
        // Fallback dla starszych przeglądarek
        const textarea = document.createElement("textarea");
        textarea.value = text;
        textarea.style.position = "fixed";
        textarea.style.left = "-9999px";
        document.body.appendChild(textarea);
        textarea.select();

        try {
            document.execCommand("copy");
        } finally {
            document.body.removeChild(textarea);
        }
    });
}

export function printElement(elementId) {
    const element = document.getElementById(elementId);
    if (!element) return;

    const printWindow = window.open("", "_blank");
    printWindow.document.write("<html><head><title>Wydruk</title>");
    printWindow.document.write('<link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css" rel="stylesheet">');
    printWindow.document.write("<style>body { padding: 20px; }</style>");
    printWindow.document.write("</head><body>");
    printWindow.document.write(element.innerHTML);
    printWindow.document.write("</body></html>");
    printWindow.document.close();

    setTimeout(() => {
        printWindow.print();
        printWindow.close();
    }, 500);
}

export function scrollToElement(elementId) {
    const element = document.getElementById(elementId);
    if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
}

export function highlightText(elementId, searchText) {
    const element = document.getElementById(elementId);
    if (!element || !searchText) return;

    const regex = new RegExp("(" + searchText.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + ")", "gi");
    element.innerHTML = element.innerHTML.replace(regex, "<mark>$1</mark>");
}
